function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M16.446 8.765a1.03 1.03 0 0 0 .296-.615l.6-5.51a1.028 1.028 0 0 0-1.134-1.134l-5.51.6c-.233.026-.45.13-.616.295l-8.28 8.282a1.028 1.028 0 0 0 0 1.454l4.909 4.91a1.028 1.028 0 0 0 1.454 0l8.281-8.282zm.708.707l-8.282 8.282a2.028 2.028 0 0 1-2.868 0l-4.91-4.91a2.028 2.028 0 0 1 0-2.868l8.281-8.282a2.028 2.028 0 0 1 1.215-.582l5.51-.6a2.028 2.028 0 0 1 2.236 2.236l-.6 5.51c-.05.46-.256.888-.582 1.214zm-3.447-5.765a1 1 0 1 1 1.414 1.414 1 1 0 0 1-1.414-1.414z"
});

var SvgSnoozes = function SvgSnoozes(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSnoozes, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Snoozes.75fbcc3f.svg";
export { ForwardRef as ReactComponent };